import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout, selectCurrentUser, selectIsAuthenticated } from '../../store/slices/authSlice';
import { useLogoutMutation } from '../../services/api';
import { getUserInitials } from '../../utils/helpers';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [logoutApi] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      dispatch(logout());
      navigate('/');
      setIsMenuOpen(false);
    }
  };

  const getNavLinks = () => {
    if (!isAuthenticated) {
      return (
        <>
          <Link to="/register" className="btn btn-secondary " >Register Restaurant</Link>
          <Link to="/login" className="btn btn-secondary ">Login</Link>
        </>
      );
    }

    switch (user?.role) {
      case 'SUPER_ADMIN':
        return (
          <>
            <Link to="/admin" className="nav-link">Admin Dashboard</Link>
            <div className="user-menu">
              <button 
                className="user-toggle"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <span className="user-avatar">
                  {getUserInitials(user.name)}
                </span>
                <span className="user-name">{user.name}</span>
              </button>
              {isMenuOpen && (
                <div className="dropdown-menu">
                  <button onClick={handleLogout} className="dropdown-item">
                    Logout
                  </button>
                </div>
              )}
            </div>
          </>
        );
      
      case 'OWNER':
        return (
          <>
            <Link to="/owner" className="btn btn-secondary"  style={{ backgroundColor: "#fff", color: "#000" }}>Dashboard</Link>
            <div className="user-menu">
              <button 
                className="user-toggle"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <span className="user-avatar" style={{
        backgroundColor: "#fff",
        color: "#000",
        borderRadius: "50%",
        padding: "8px 12px",
        fontWeight: "600",
      }}>
                  {getUserInitials(user.name)}
                </span>
                <span className="user-name" style={{
        backgroundColor: "#fff",
        color: "#000",
        marginLeft: "8px",
        padding: "6px 10px",
        borderRadius: "6px",
        fontWeight: "500",
      }}>{user.name}</span>
              </button>
              {isMenuOpen && (
                <div className="dropdown-menu">
                  <button onClick={handleLogout} className="dropdown-item">
                    Logout
                  </button>
                </div>
              )}
            </div>
          </>
        );
      
      default:
        return (
          <>
            <Link to="/login" className="btn btn-primary">Login</Link>
          </>
        );
    }
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = () => setIsMenuOpen(false);
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
         <Link to="/" className="nav-brand">
  <img src="/logo.png" alt="Cafe.WebReady24 Logo" height={50} width={200}/>
</Link>

          
          <div className="nav-links">
            {getNavLinks()}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;